import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { showKeyboard, sendInputKeyboard } from '../../../containers/App/actions';
import { connect } from 'react-redux';
import { makeSelectKeyboardState } from '../../../containers/App/selectors';

class KeyboardedInput extends React.Component {
  static propTypes = {
    name: PropTypes.any,
    className: PropTypes.any,
    placeholder: PropTypes.any,
    value: PropTypes.any,
    label: PropTypes.node,
    type: PropTypes.any,
    min: PropTypes.any,
    max: PropTypes.any,
    step: PropTypes.any,
    pattern: PropTypes.any,
    readOnly: PropTypes.any,
    enabled: PropTypes.any,
    defaultKeyboard: PropTypes.any,
    secondaryKeyboard: PropTypes.any,
    opacity: PropTypes.any,
    isDraggable: PropTypes.any,
    isFirstLetterUppercase: PropTypes.any,
    dataset: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    helperText: PropTypes.node,
    id: PropTypes.string,
    size: PropTypes.string,
    inputMode: PropTypes.string,
    keyboardLayout: PropTypes.string,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    multiline: PropTypes.bool,
    minRows: PropTypes.number,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    InputProps: PropTypes.object,
    InputLabelProps: PropTypes.object,
    textFieldProps: PropTypes.object,
    inputProps: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleFocusLost = this.handleFocusLost.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.hideKeyboard = this.hideKeyboard.bind(this);

    this.state = {
      showKeyboard: true,
      input: null
    };
  }

  componentDidMount() {
    this.input.addEventListener('input', this.handleChange);
    this.oldValue = this.props.value;
  }

  componentWillUnmount() {
    this.input.removeEventListener('input', this.handleChange);
  }

  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
    event.stopPropagation();
  }

  handleFocus(event) {
    // Prevent blinking of the keyboard if opaque
    setTimeout(() => {
      if (this.input != null) {
        this.input.focus();
        // this.input.select();
        this.props.showKeyboard(true);
        this.props.sendInputKeyboard(this.input);
      }
    }, 0);
  }

  handleFocusLost() {
    // const that = this;
    setTimeout(() => {
      if (
        !document.activeElement.classList.contains('react-draggable-transparent-selection') &&
        !document.activeElement.classList.contains('keyboard-button') &&
        !document.activeElement.classList.contains('keyboard') &&
        !document.activeElement.classList.contains('keyboard-row')
      ) {
        // that.setState({ ...that.state, showKeyboard: true });
        this.props.showKeyboard(false);
        // this.props.sendInputKeyboard(null);
      }
    }, 0);
  }

  hideKeyboard() {
    this.setState({ ...this.state, showKeyboard: true });
    // this.props.showKeyboard(false);
  }

  render() {
    const dataAttributes = this.props.dataset
      ? Object.entries(this.props.dataset).reduce((acc, [key, value]) => {
          acc[`data-${key}`] = value;
          return acc;
        }, {})
      : {};

    if (this.props.keyboardLayout) {
      dataAttributes['data-keyboard-layout'] = this.props.keyboardLayout;
    }

    const inputMode = this.props.inputMode || (this.props.type === 'number' ? 'numeric' : undefined);

    const inputProps = {
      step: this.props.step,
      className: this.props.className,
      style: this.props.style,
      type: this.props.type,
      onFocus: this.handleFocus,
      onBlur: this.handleFocusLost,
      min: this.props.min,
      max: this.props.max,
      pattern: this.props.pattern,
      onChange: this.handleChange,
      onClick: (e) => {
        e.stopPropagation();
      },
      onKeyDown: (e) => {
        e.stopPropagation();
      },
      readOnly: this.props.readOnly === true,
      ref: (e) => (this.input = e),
      ...dataAttributes,
      ...this.props.inputProps
    };

    if (inputMode) {
      inputProps.inputMode = inputMode;
    }

    return (
      <div>
        <TextField
          id={this.props.id}
          value={this.props.value}
          error={this.props.error}
          helperText={this.props.helperText}
          color="secondary"
          variant={this.props.variant !== undefined ? this.props.variant : 'outlined'}
          disabled={this.props.disabled}
          label={this.props.label}
          placeholder={this.props.placeholder}
          size={this.props.size}
          multiline={this?.props?.multiline}
          minRows={this?.props?.minRows}
          fullWidth={this?.props?.fullWidth}
          sx={this.props.sx}
          InputProps={this.props.InputProps}
          inputProps={inputProps}
          InputLabelProps={{
            ...this.props.InputLabelProps,
            shrink: this.props.type === 'datetime-local' || (this.props.value !== undefined && this.props.value !== null && this.props.value !== '') ? true : undefined,
            style: this.props.inputlabelprops
          }}
          {...this.props.textFieldProps}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showKeyboard: (open) => dispatch(showKeyboard(open)),
    sendInputKeyboard: (input) => dispatch(sendInputKeyboard(input))
  };
}

const mapStateToProps = makeSelectKeyboardState();

KeyboardedInput.propTypes = {
  showKeyboard: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(KeyboardedInput);
